export const InstructionTileSkeleton = () => (
  <div className="aspect-[4/5] rounded-2xl bg-muted/40 animate-pulse" />
)
